import { render, staticRenderFns } from "./ChromeExtensionLanding.vue?vue&type=template&id=72890a1b&scoped=true&"
import script from "./ChromeExtensionLanding.vue?vue&type=script&lang=js&"
export * from "./ChromeExtensionLanding.vue?vue&type=script&lang=js&"
import style0 from "./ChromeExtensionLanding.vue?vue&type=style&index=0&id=72890a1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72890a1b",
  null
  
)

export default component.exports